/**
 * Currency symbol mapping
 */
const CURRENCY_SYMBOLS: Record<string, string> = {
  AUD: '$',
  USD: '$',
  CAD: 'C$',
  SGD: 'S$',
  NZD: 'NZ$',
  HKD: 'HK$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  INR: '₹',
  KRW: '₩',
  THB: '฿',
  MYR: 'RM',
  IDR: 'Rp',
  PHP: '₱',
  VND: '₫',
  CHF: 'CHF',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  BGN: 'лв',
  TRY: '₺',
  ILS: '₪',
  ZAR: 'R',
  BRL: 'R$',
  MXN: 'Mex$',
  ARS: 'AR$',
  CLP: 'CLP$',
  COP: 'COL$',
  PEN: 'S/',
}

/**
 * Get currency symbol for a given currency code
 */
function getCurrencySymbol(currency: string): string {
  return CURRENCY_SYMBOLS[currency.toUpperCase()] || currency
}

/**
 * Format a number as currency with proper thousand separators and decimal places
 * @param amount - The amount to format
 * @param currency - Currency code (default: 'AUD')
 * @param showCurrency - Whether to show currency symbol (default: true)
 * @returns Formatted currency string
 */
export function formatCurrency(
  amount: number | string,
  currency: string = 'AUD',
  showCurrency: boolean = true,
): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount

  if (isNaN(numAmount)) {
    return showCurrency ? `${getCurrencySymbol(currency)} 0.00` : '0.00'
  }

  // Format with thousand separators and 2 decimal places
  const formatted = numAmount.toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  if (showCurrency) {
    const symbol = getCurrencySymbol(currency)
    return `${symbol} ${formatted}`
  }

  return formatted
}

/**
 * Format currency for display in tables and lists
 * Shows currency symbol by default
 */
export function formatAmount(
  amount: number | string,
  currency: string = 'AUD',
  showSymbol: boolean = true,
): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount

  if (isNaN(numAmount)) {
    return showSymbol ? `${getCurrencySymbol(currency)} 0.00` : '0.00'
  }

  const formatted = numAmount.toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  if (showSymbol) {
    const symbol = getCurrencySymbol(currency)
    return `${symbol} ${formatted}`
  }

  return formatted
}
